import { makeAutoObservable, runInAction } from 'mobx';
import { getCookie } from '../utils/utils';
import ScoReflectClient from './ScoReflectClient';
import { NavigateFunction } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

interface IUserData {
  UserID: string;
  ShortID: string;
  PhoneNumber: string;
  Email: string | undefined;
  NickName: string | undefined;
  FirstName: string | undefined;
  LastName: string | undefined;
  Sex: number | undefined;
  Birthday: string | undefined;
  Photo: string | undefined;
  RoleID: string;
}

interface IGame {
  UserID: string;
  MapID: string;
  Time: string;
  CreatedAt: string;
}

interface IDay {
  Day: string;
  Opened: boolean;
  Games: IGame[];
}

class UserStore {
  private _id: string | undefined;
  private _phoneNumber: string | undefined;
  private _shortId: string | undefined;
  private _roleId: string | undefined;
  private _birthday: string | undefined;
  private _email: string | undefined;
  private _nickName: string | undefined;
  private _firstName: string | undefined;
  private _lastName: string | undefined;
  private _sex: number | undefined;
  private _photo: string | undefined;
  private _games: IGame[] = [];
  private _days: IDay[] = [];

  public get id(): string | undefined {
    return this._id;
  }

  public get nickName(): string | undefined {
    return this._nickName;
  }

  public get phoneNumber(): string | undefined {
    return this._phoneNumber;
  }

  public get firstName(): string | undefined {
    return this._firstName;
  }

  public get lastName(): string | undefined {
    return this._lastName;
  }

  public get sex(): number | undefined {
    return this._sex;
  }

  public get email(): string | undefined {
    return this._email;
  }

  public get birthday(): string | undefined {
    if (this._birthday && this._birthday.toString() === '01.01.0001')
      return undefined;

    return this._birthday;
  }

  public get shortId(): string | undefined {
    return this._shortId;
  }

  public get roleId(): string | undefined {
    return this._roleId;
  }

  public get photo(): string | undefined {
    return this._photo;
  }

  public get games(): IGame[] {
    return this._games;
  }

  public get days(): IDay[] {
    return this._days;
  }

  constructor() {
    makeAutoObservable(this);
  }

  public async fetchGames() {
    try {
      const response = await ScoReflectClient.request('/rating/user', { ShortId: this._shortId });

      if (response.status === 200) {
        const games = response.data as IGame[];;
        runInAction(() => {
          this._games = [];
          this._days = [];
          this._games = games;
          this._games.forEach(game => {
            const date = new Date(game.CreatedAt);
            let day = this._days.find(x => x.Day === date.toLocaleDateString("ru-RU"));
            
            if (!day) {
              const length = this._days.push({
                Day: date.toLocaleDateString("ru-RU"),
                Opened: false,
                Games: []
              });

              day = this._days[length-1];
            }

            day.Games.push(game);
          });
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  public getUserData() {
    try {
      const accessToken = getCookie('AccessToken');
      if (!accessToken) return;

      //const accessTokenData = atob(accessToken.split('.')[1]);
      const userData: IUserData = jwtDecode(accessToken);//JSON.parse(accessTokenData);
      this._id = userData.UserID;
      this._shortId = userData.ShortID;
      this._phoneNumber = userData.PhoneNumber;
      this._email = userData.Email;
      this._nickName = userData.NickName;
      this._firstName = userData.FirstName;
      this._lastName = userData.LastName;
      this._sex = userData.Sex;
      this._photo = userData.Photo;
      if (userData.Birthday) {
        const date = userData.Birthday.split('T')[0];
        const dateParts = date.split('-');
        this._birthday = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
      }
      this._roleId = userData.RoleID;
    } catch (e) {
      console.log(e)
    }
    
  }

  public async logout(navigate: NavigateFunction) {
    try {
      const response = await ScoReflectClient.request('/auth/logout');

      if (response.status === 200) {
        this._id = undefined;
        this._shortId = undefined;
        this._phoneNumber = undefined;
        this._email = undefined;
        this._nickName = undefined;
        this._firstName = undefined;
        this._lastName = undefined;
        this._sex = undefined;
        this._birthday = undefined;
        this._photo = undefined;
        this._roleId = undefined;
        navigate('/');
      }
    } catch (error) {
      console.log(error);
    }
  }
}

// eslint-disable-next-line
export default new UserStore();